<template>
  <v-container id="employee-report" fluid tag="section">
    <FilterForm 
      :filterForm="filterForm" 
      :ministries="ministries"
    />

    <ContactSourceReportTable
      :dataReport="dataReport"
    />

  </v-container>
</template>

<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment'
import { formatDate } from '@/helpers/utils'
import FilterForm from './components/FilterForm'
import ContactSourceReportTable from './components/ContactSourceReportTable'

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
  components: { FilterForm, ContactSourceReportTable },
  data () {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        ministryIds: [],
        shift: []
      },
      dataReport: {},
      watchModule: '',
      ministries: []
    }
  },

  created () {
    this.getListMinistry()
    this.fetchData()
    Bus.$on('contact-source-report-filter', (filterForm) => {
      this.filterForm = filterForm
      this.fetchData()
    })

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          dateRange: {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          shift: [],
          ministryIds: []
        }
      
        Bus.$emit('contact-source-report-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('contact-source-report-filter');
    this.watchModule()
  },
  methods: {
    async fetchData () {
      const loader = this.$loading.show()

      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        shift: this.filterForm.shift,
        ministryIds: this.filterForm.ministryIds,
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
      }

      const response = await ReportRepository.contactSource(params)

      loader.hide()

      if (_.get(response, 'success', false)) {
        this.dataReport = _.get(response, 'data')
      } else {
        this.dataReport = {}
      }
    },

    async getListMinistry() {
      const res = await OrganizationMachineRepository.listMinistryOnly()

      if (res.success) {
        this.ministries = _.get(res, 'data', [])
      } else {
        this.ministries = []
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  },
}
</script>
